import Model from './Model'

export default class KAMFormModel extends Model {
  id!: number

  resource () : string {
    return 'kamForms'
  }
}
